export default __webpack_public_path__ + "static/media/colombia-circle.2c4c7a0c.svg";